import { AlertCircleIcon, Edit03Icon, Image01Icon } from '@/components/ui/icons'
import {
	OpsVettingCardContainer,
	OpsVettingImage
} from '@/features/ops-vetting/components/ops-vetting-atoms'
import { useTranslation } from '@/translations/i18n'

interface ProPhotosServiceCardProps {
	title: string
	description: string
	coverImageUrl?: string | null
	onCardClick: () => void
}
export const ProPhotosServiceCard = ({
	title,
	description,
	coverImageUrl,
	onCardClick
}: ProPhotosServiceCardProps) => {
	const { t } = useTranslation()

	return (
		<OpsVettingCardContainer
			direction='column'
			fullWidth
			gap={2}
			onClick={() => onCardClick()}
			style={{ cursor: 'pointer' }}
		>
			<div className='grid w-full grid-cols-[64px_1fr] items-start gap-3 [&:hover_.hide-on-hover]:opacity-0 [&:hover_.show-on-hover]:opacity-100 [&_.hide-on-hover]:opacity-100 [&_.hide-on-hover]:transition-opacity [&_.hide-on-hover]:duration-150 [&_.hide-on-hover]:ease-in-out [&_.show-on-hover]:opacity-0 [&_.show-on-hover]:transition-opacity [&_.show-on-hover]:duration-150 [&_.show-on-hover]:ease-in-out'>
				{coverImageUrl ? (
					<div className='relative h-16 w-full'>
						<OpsVettingImage src={coverImageUrl} />
						<div className='show-on-hover absolute inset-0 h-16 w-full rounded-lg bg-neutral-black/60 shadow-xs'>
							<Edit03Icon className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 fill-neutral-white' />
						</div>
					</div>
				) : (
					<div className='relative h-16 rounded-lg border border-black/20 bg-neutral-100'>
						<Image01Icon className='hide-on-hover absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 fill-neutral-600' />
						<Edit03Icon className='show-on-hover absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 fill-neutral-600' />
					</div>
				)}

				<div className='flex flex-col gap-1 overflow-hidden text-neutral-900'>
					<h4 className='w-full overflow-hidden text-ellipsis font-medium'>
						{title}
					</h4>
					<p className='text-sm'>{description}</p>

					{!coverImageUrl && (
						<p className='flex gap-1.5 text-danger-600 text-sm'>
							<AlertCircleIcon size={20} />
							{t('vetting:reordering.missing_photo')}
						</p>
					)}
				</div>
			</div>
		</OpsVettingCardContainer>
	)
}
